// extracted by mini-css-extract-plugin
export default {"flex":"ingredient-section_flex__B1Rqh","lastOdd":"ingredient-section_lastOdd__AHCQ8","navLink":"ingredient-section_navLink__ozujo"};